import styles from "./Spinner.module.css";

export function Spinner({ label }: { label: string }) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <svg className={styles.ring} width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray="42 100"
          strokeLinecap="round"
        />
      </svg>
      <span className={styles.text}>{label}</span>
    </div>
  );
}
